import documentTypeReducer from './reducers';

export { default as documentTypeActions } from './actions';
export { default as documentTypeSelectors } from './selectors';

export default documentTypeReducer;
